export default "__VITE_ASSET__Bh2SoD3V__"